import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../spinner.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

	loading = new BehaviorSubject<boolean>(null);

	constructor(private spinnerService: SpinnerService) { }


	ngOnInit() {


		this.spinnerService.isLoading.subscribe((v) => {
			//console.log("spinner içerisindeyim: " + v);

			if (v == 0) {
				this.loading.next(false);
			}
			else {
				this.loading.next(true);

			}
			//this.loading.next(v);
		});
  }

}
